import React from 'react';
import { Helmet } from "react-helmet";
import { NavMenu } from '../NavMenu';
import { Footer } from '../Footer';
/*import { DefaultStyle } from '@americanexpress/dls-react';*/
import { CONSTANTS} from '../../constants';

function Layout(props) {
    const domain = window.location.hostname;
    const renderScriptSupplierLink=()=>{
       if (domain.toLowerCase() === CONSTANTS.prodUrl.lmsProd.toLowerCase() || domain.toLowerCase() === CONSTANTS.prodUrl.mediaCampProd.toLowerCase()) {
           return <script src="https://www.aexp-static.com/cdaas/one/axp-script-supplier/6.0.0/script-supplier.js"
               integrity="sha256-HKi0HKl/uMphjJqQF5498h48dRPTEF1pQEV/f92X+QM=" crossorigin="anonymous" async></script>
       }
       else if (domain.toLowerCase() === CONSTANTS.qaUrl.lmsQA.toLowerCase()) {
           return <script src="https://qwww.aexp-static.com/cdaas/one/axp-script-supplier/6.0.0/script-supplier.js"
               integrity="sha256-4Xsb3vFTFt/mj//sMVh9b1oZfi12MMGOCU6DFBC0hZY=" crossorigin="anonymous" async></script>
       }
       else { 
           return <script src="https://cdaas-dev.americanexpress.com/one/axp-script-supplier/6.0.0/script-supplier.js"
               integrity="sha256-4f/1ON+oxoua4ZOtFDbjlljSaHp2F9YDSYfn5eRHPT4=" crossorigin="anonymous" async></script>
       }
   }

    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>American Express</title>
                {/*<DefaultStyle />*/}
                <link rel="stylesheet" href="https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.19.0/package/dist/6.19.0/styles/dls.min.css" />
            </Helmet>
            <NavMenu />
            {props.children}
            <Helmet>
                <script type="text/javascript" src="https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.19.0/package/dist/6.19.0/scripts/dls.min.js"></script>
                { renderScriptSupplierLink() }
            </Helmet>            
            <Footer />
        </div>
    );
}
export default Layout;
